import styled from "@emotion/styled";
import { Accordion } from "@mui/material";

export const TrucksLandingPageHeader = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	width: "100%",
	boxSizing: "border-box",
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: "15px 20px",
	h5: {
		margin: 0,
		color: theme.project.colors.primaryColors.main
	},
	"& .MuiTabs-root": {
		minHeight: "42px",
		button: {
			minHeight: "42px",
			letterSpacing: ".4px"
		},
		"& .Mui-selected": {
			color: theme.project.colors.primaryColors.main
		},
		"& .MuiTabs-indicator": {
			backgroundColor: theme.project.colors.primaryColors.main
		}
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		alignItems: "flex-start",
		padding: 20
	}
}));

export const TrucksLandingPageContent = styled.div(({ theme }) => ({
	padding: "16px 20px"
}));

export const OpenTrucksTableAccordion = styled(Accordion)(({ theme }) => ({
	"& .MuiAccordionSummary-root": {
		backgroundColor: theme.project.colors.allColors.hex.blue.light.lightBlue50,
		h6: {
			margin: 0,
			color: theme.project.colors.primaryColors.main
		},
		"& .MuiAccordionSummary-content": {
			margin: "8px 0"
		},
		svg: {
			color: theme.project.colors.primaryColors.main
		}
	},
	"& .MuiAccordionDetails-root": {
		padding: "16px"
	}
}));

export const OpenTrucksTableContainer = styled.div({
	overflowX: "auto",
	marginBottom: "16px"
});
